/*
 * Copyright (c) 2018-present, Revolut LTD.
 *
 * This source code is licensed under the Apache 2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

import * as React from 'react'
import { mount } from 'enzyme'
import { Button } from './index'

test('Component is rendering and showing content', () => {
  const text = 'Hello world!'
  const component = mount(<Button>{text}</Button>)
  expect(component.prop('children')).toBe('Hello world!')
})
